import { forwardRef, InputHTMLAttributes } from 'react'
import { FieldErrors } from 'react-hook-form'
import { cn } from '@/utils/classnames'
import FormErrorMessage from './FormErrorMessage'

export interface RadioProps extends InputHTMLAttributes<HTMLInputElement> {
  name?: string
  label: string
  disabled?: boolean
  errors?: FieldErrors
  'data-testid': string
}

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      id,
      name,
      label,
      className,
      errors,
      disabled = false,
      'data-testid': testId,
      ...props
    },
    ref
  ) => {
    const radioClassNames = cn(
      'elm-radio',
      'dark:bg-cool-gray-700',
      'dark:hover:!bg-cool-gray-700',
      'dark:border-cool-gray-200',
      'dark:checked:!bg-cool-gray-700',
      'dark:checked:hover:!bg-cool-gray-700'
    )

    return (
      <div className={className} data-testid={`${testId}-wrapper`}>
        <div>
          <label
            className="elm-label"
            htmlFor={id}
            aria-hidden="true"
            id={`${id}-label`}
            data-testid={`${testId}-label`}
          >
            <input
              type="radio"
              id={id}
              name={name}
              className={radioClassNames}
              disabled={disabled}
              ref={ref}
              data-testid={testId}
              {...props}
            />
            <span className="ml-0.5">{label}</span>
          </label>
        </div>
        {name && errors && (
          <FormErrorMessage
            errors={errors}
            name={name}
            data-testid={`${testId}-error-message`}
          />
        )}
      </div>
    )
  }
)

Radio.displayName = 'Radio'

export default Radio
